import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** CREATE ACTIONS ***
// -----

export const Create_3004: ActionInfo = {
  id: "create_3004",
  type: "Create",
  title: "Brick 1x2 (+1)",
  details: "+1 Brick 1x2",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 2,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 1,
    },
  ],
  actionVisibility: [
    {
      actionId: "split_3005_into_3024",
    },
    {
      actionId: "split_3004_into_3023",
    },
  ],
  isBrickpack: false,
};

export const Create_3010: ActionInfo = {
  id: "create_3010",
  type: "Create",
  title: "Brick 1x4 (+1)",
  details: "+1 Brick 1x4",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 2,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 1,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3010",
    },
    {
      actionId: "increase_capacity_3010",
    },
  ],
  isBrickpack: false,
};

export const Create_3003: ActionInfo = {
  id: "create_3003",
  type: "Create",
  title: "Brick 2x2 (+1)",
  details: "+1 Brick 2x2",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 2,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 1,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3003",
    },
    {
      actionId: "increase_capacity_3003",
    },
  ],
  isBrickpack: false,
};

export const Create_3001: ActionInfo = {
  id: "create_3001",
  type: "Create",
  title: "Brick 2x4 (+1)",
  details: "+1 Brick 2x4",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 2,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 1,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3001",
    },
    {
      actionId: "increase_capacity_3001",
    },
  ],
  isBrickpack: false,
};
